import { useEffect, useState } from "react";

const cols = [
  {
    title: "实时栏目",
    links: ["突发直击", "城市现场", "体育现场", "文娱现场", "科技前沿"],
  },
  {
    title: "关于平台",
    links: ["关于我们", "在场原则", "编辑部手记", "报料指引", "常见问题"],
  },
  {
    title: "商务与支持",
    links: ["联系我们", "媒体合作", "内容授权", "免责声明", "隐私政策"],
  },
];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="relative bg-background-200/80 border-t border-background-300">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-12 md:pt-14 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-fill text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-black text-lg text-foreground-950">直击现场</span>
                <span className="text-[10px] text-foreground-500 tracking-[0.28em] mt-0.5">LIVE · 第一现场</span>
              </span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              我们就在现场，实时爆料、现场直击、实况同步，替你捕捉每一个值得被看见的瞬间。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {["ri-wechat-fill", "ri-facebook-circle-fill", "ri-instagram-line", "ri-mail-fill"].map((ic) => (
                <a key={ic} href="#report" aria-label="平台联系方式" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 border border-background-300 text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors">
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h3 className="font-heading font-bold text-foreground-950 mb-4">{c.title}</h3>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 直击现场 · 在现场，看第一现场</p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-600">服务条款</a>
            <a href="#top" className="hover:text-primary-600">隐私政策</a>
            <span className="inline-flex items-center gap-1"><i className="ri-radio-2-line text-primary-500" /> 现场连线中</span>
          </div>
        </div>
      </div>

      {showTop && (
        <a
          href="#top"
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 shadow-none hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-up-line text-lg" />
        </a>
      )}
    </footer>
  );
}